var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',[_vm._v(" Created by: "),_c('a',{attrs:{"href":_vm.myWebsiteHttps}},[_vm._v(_vm._s(_vm.myWebsite))])])])}
var staticRenderFns = []

export { render, staticRenderFns }